import { app } from '../../../../../app';
import { Controller } from './add-account.controller';

app.component('companyUserDirectoriesManageUserAddAccount', {
    bindings: {
        accountsForCompanyUser: '<',
        companyId: '<',
        companyUser: '<',
    },
    controller: Controller,
    templateUrl: require('./add-account.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/add-account/add-account.component.js